import AnimatedSection from "@/components/common/AnimatedSection";
import PageHero from "@/components/common/PageHero";
import PageTransition from "@/components/layout/PageTransition";

const services = [
  "Smile design planning",
  "Tooth reshaping and contouring",
  "Aesthetic restorative solutions",
  "Whitening guidance and maintenance",
];

export default function AestheticDentistryPage() {
  return (
    <PageTransition testId="aesthetic-dentistry-page">
      <PageHero
        title="Aesthetic Dentistry"
        subtitle="Natural-looking smile enhancements tailored to your facial balance and comfort."
        image="https://images.unsplash.com/photo-1593022356769-11f762e25ed9?auto=format&fit=crop&w=2000&q=80"
        testId="aesthetic-dentistry-page-hero"
      />

      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-24">
        <AnimatedSection testId="aesthetic-dentistry-content-section">
          <div className="rounded-2xl border border-[#f2e6c9] bg-white p-8">
            <h2
              className="font-[Playfair_Display] text-3xl text-[#1a1a1a]"
              data-testid="aesthetic-dentistry-services-title"
            >
              Core Aesthetic Services
            </h2>
            <ul className="mt-5 space-y-2">
              {services.map((item) => (
                <li
                  key={item}
                  className="font-[Manrope] text-sm text-[#555555]"
                  data-testid={`aesthetic-dentistry-service-${item
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  • {item}
                </li>
              ))}
            </ul>
          </div>
        </AnimatedSection>
      </div>
    </PageTransition>
  );
}
